import { Box, styled, useTheme } from '@mui/material'
import EidTableGrid from 'components/EidTableGrid/EidTableGrid'
import { useApplicationRoleDefinitionsAssignments } from 'hooks'
import { useTranslation } from 'react-i18next'
import { Button, Filters } from 'components'
import { Icon } from 'packages/eid-icons'
import { getFullPathFromUrl, useQuery } from 'packages/core'
import { useHistory } from 'react-router'
import config from 'config'
import UnAssignAssignment from '../Assignments/UnAssignAssignment'
import AssigneePerson from 'components/AssigneePerson/AssigneePerson'
import FieldTypeJsonPreviewButton from 'components/FieldTypeJsonPreview'
import DateTimeGenericComponent from 'components/DynamicComponents/DateTimeGenericComponent'

const TableOverView = styled(Box)({
    '& table': {
        boxShadow: '0 4px 17px 0 rgba(0, 0, 0, 0.07)',
    },
})
const SearchMenuBarFilter = styled(Box)({
    width: '100%',

    '& svg': {
        color: ' #aab0b4',
        marginRight: '3px',
    },
    '& div:nth-child(1)': {
        boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.1) !important',
        border: 'solid 1px #ebebed',
        paddingLeft: '0',
        height: '40px',
    },
    '& ::placeholder': {
        color: '#aab0b4',
    },
})

const ButtonsBox = styled(Box)({
    display: 'flex',
    paddingRight: '10px',
    justifyContent: 'flex-end',
})

const RoleDefinitionAssignments = ({ roleId, resourceId }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const query = useQuery()
    const history = useHistory()

    const { list, loading, loadingMore, pagination, refetch } =
        useApplicationRoleDefinitionsAssignments(roleId)

    const attributes = [
        {
            name: 'assignee',
            sortable: true,
            label: 'Assignee',
            hideValue: true,
            component: {
                componentName: 'renderer',
                render: (data) => {
                    return (
                        <AssigneePerson
                            assigneeName={data.assignee}
                            imageUrl={data.personImageThumbUrl}
                            assigneeType={data.type}
                        />
                    )
                },
            },
        },
        {
            name: 'role',
            sortable: true,
            label: 'Role',
        },
        {
            name: 'assignedTo',
            sortable: true,
            label: 'AssignedTo',
        },

        {
            name: 'tenant',
            sortable: true,
            label: 'Tenant',
        },
        {
            name: 'startDate',
            sortable: true,
            label: 'StartDate',
            styles: {
                color: '#282828',
            },
            hideValue: true,
            component: {
                componentName: 'renderer',
                render: (data) => (
                    <DateTimeGenericComponent
                        data={data}
                        attribute={{ name: 'startDateUtc' }}
                        format={'lll'}
                    />
                ),
            },
        },
        {
            name: 'endDate',
            sortable: true,
            label: 'EndDate',
            styles: {
                color: '#282828',
            },
            hideValue: true,
            component: {
                componentName: 'renderer',
                render: (data) => (
                    <DateTimeGenericComponent
                        data={data}
                        attribute={{ name: 'endDateUtc' }}
                        format={'lll'}
                    />
                ),
            },
        },
        {
            hideValue: true,
            component: {
                componentName: 'renderer',
                render: (data) => {
                    return (
                        <ButtonsBox>
                            <FieldTypeJsonPreviewButton data={data} />
                            <UnAssignAssignment
                                assignmentId={data?.id}
                                refetch={refetch}
                                friendlyName={data?.assignee}
                            />
                        </ButtonsBox>
                    )
                },
            },
        },
    ]

    return (
        <Box>
            <Box
                width="100%"
                display="flex"
                alignItems="space-between"
                justifyContent="space-between"
                padding="16px 30px"
            >
                <Button
                    onClick={() => {
                        query.delete('applicationId')
                        query.delete('roleDefinitionId')
                        query.set('workflowName', 'AssignAzLocalRoleScope')
                        query.set('returnUrl', getFullPathFromUrl())
                        query.set('SelectedResourceID', resourceId)
                        history.push(
                            `${
                                config.APP_SUBPATH
                            }/applications/workflows?${query.toString()}`,
                        )
                    }}
                    style={{
                        borderRadius: '4px',
                        padding: '0px 20px',
                        backgroundColor: theme?.palette?.primary?.main,
                        border: 'solid 1px #01ae8f',
                        color: '#ffffff',
                        fontSize: '14px',
                        '&:hover': {
                            backgroundColor: theme?.palette?.primary?.main,
                        },
                    }}
                >
                    <Box style={{ display: 'flex' }}>
                        <Icon
                            name={'Plus'}
                            fill="white"
                            style={{
                                width: '16px',
                                height: '16px',
                                marginRight: '5px',
                            }}
                        />
                        {t('AddAssignment')}
                    </Box>
                </Button>

                <Box
                    width="240px"
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                >
                    <SearchMenuBarFilter>
                        <Filters.TextSearch outlined />
                    </SearchMenuBarFilter>
                </Box>
            </Box>
            <TableOverView>
                <EidTableGrid
                    noDataMessage={t('NoDataMessage')}
                    pagination={pagination}
                    sLoading={loading}
                    isLoadingMore={loadingMore}
                    attributes={attributes}
                    list={list}
                />
            </TableOverView>
        </Box>
    )
}

export default RoleDefinitionAssignments
